import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const RAM_LANGUAGE_STORAGE_KEY = '__RAM_SELECTED_LANGUAGE__';

export const SUPPORTED_RAM_LANGUAGES = ['en', 'de'] as const;
export const DEFAULT_RAM_LANGUAGE = 'en';

export type RamLanguage = (typeof SUPPORTED_RAM_LANGUAGES)[number];

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .use(resourcesToBackend((language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)))
    .use(
        new LanguageDetector(null, {
            lookupLocalStorage: RAM_LANGUAGE_STORAGE_KEY,
        }),
    )
    .init({
        interpolation: {
            escapeValue: false, // react already safes from xss => https://react.i18next.com/translation-function/interpolation#unescape
        },
        lng: DEFAULT_RAM_LANGUAGE,
        fallbackLng: DEFAULT_RAM_LANGUAGE,
        supportedLngs: SUPPORTED_RAM_LANGUAGES,
        // Preload shared chrome + API error toasts (non-React handlers use i18n.t)
        ns: ['main'],
        defaultNS: 'main',
    });

export default i18n;
